import { defineComponent } from 'vue';
import axios, { AxiosResponse } from 'axios';
import DCApp from "./../Shared/App.vue";
import * as Vue from 'vue';
import { Field, Form, ErrorMessage, useField, useForm } from 'vee-validate';
import * as yup from 'yup';
import { String as StringS } from 'typescript-string-operations';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import ownCaptchaComponent from './../Shared/OwnCaptcha.vue';
import { createPinia } from 'pinia';
import { ClientJS } from "clientjs";

let gstatutreu: string = "";
let gstatutfail: string = "";
let glancurrent: string;
glancurrent = "fr";
let gcaptchapublickey: string;
let gview_register_validate_requis: string = "";
let gview_register_validate_emailinvalid: string = "";
gcaptchapublickey = "";
export class ContactInfo {

    public  emailfrom: string = "";

    public  subject: string = "";

    public  content: string = "";

        public  raison: number = 0;

    public  contactname: string = "";
    public captcharesponse: string = "";
    }

const mixin = defineComponent({
    components: { ownCaptchaComponent, Field, Form, ErrorMessage },
    data() {
        const applyButtonUsed = false;
        const isInteractionDetected = false;
        const schema = yup.object({
            emailfrom: yup.string().required(gview_register_validate_requis).email(gview_register_validate_emailinvalid),
            subject: yup.string().required(gview_register_validate_requis),
            content: yup.string().required(gview_register_validate_requis),
            contactname: yup.string().required(gview_register_validate_requis),
            raison: yup.string().required(gview_register_validate_requis),
        });
        useForm({
            validationSchema: schema,
        });
        const { value: emailfrom, errorMessage: emailfrom_err } = useField(
            "emailfrom"
        );
        const { value: subject, errorMessage: subject_err } = useField(
            "subject"
        );
        const { value: content, errorMessage: content_err } = useField(
            "content"
        );
        const { value: contactname, errorMessage: contactname_err } = useField(
            "contactname"
        );
        const { value: raison, errorMessage: raison_err } = useField(
            "raison"
        );
        return {
            applyButtonUsed,
            isInteractionDetected,
            lancurrent:"",
            status: "",
            hassendmail:false,
            emailfrom,
            subject,
            content,
            contactname,
            raison,
            raison_err,
            emailfrom_err,
            subject_err,
            content_err,
            contactname_err,

            captchapublickey: "",
            statutreu: "",
            statutfail: "",
            nonce: "",
            signature: "",
            userFingerPrint: 0,
            honeyPotName: "",
            honeyPotValue: ""
        };
    },
   
    created() {
        this.statutreu = gstatutreu;
        this.statutfail = gstatutfail;
        this.captchapublickey = gcaptchapublickey;
        this.lancurrent = glancurrent;
        },
    methods: {
        getFingerPrint() {
            const client = new ClientJS();
            this.userFingerPrint = client.getFingerprint();
        },

        handleValidationStatus(applyButtonUsedVal: boolean, isInteractionDetectedVal: boolean) {
            // Mise à jour des données basées sur l'enfant
            this.applyButtonUsed = applyButtonUsedVal;
            this.isInteractionDetected = isInteractionDetectedVal;
        },

        handleCaptchaReady(nonce: string, signature: string, honeyPotName: string, honeyPotValue: string) {
            this.nonce = nonce;
            this.signature = signature;
            this.honeyPotName = honeyPotName;
            this.honeyPotValue = honeyPotValue;
        },

        SendContactInfos() {
            if (this.applyButtonUsed || !this.isInteractionDetected) {
                return false;
            }

            this.getFingerPrint();

            const contact: any = new Object();
            contact['emailfrom'] = this.emailfrom;
            contact['subject'] = this.subject;
            contact['content'] = this.content;
            contact['raison'] = this.raison;
            contact['contactname'] = this.contactname;
            contact['Nonce'] = this.nonce;
            contact['Signature'] = this.signature;
            contact['UserFingerPrint'] = this.userFingerPrint;
            contact[this.honeyPotName] = this.honeyPotValue;
            this.SendContact(contact);
            },

     SendContact(contact: Object) {
                const url = "/api/v1.0/contact/SendContact";
         const self = this;
         self.hassendmail = true;
         axios.post<boolean>(url, contact).then(function (response: AxiosResponse<boolean>) {
                    if (response !== null) {
                        if (response.data) {
                            self.status = self.statutreu;
                        
                            Swal.fire({
                                toast: true,
                                position: 'top-end',
                                customClass: {
                                    container: 'dctoastcontainer'
                                },
                                icon: 'success',
                                title: self.status,
                                showConfirmButton: false,
                                timer: 2500
                            });
                        }
                        else {
                            self.status = self.statutfail;
                            self.hassendmail = false;
                            Swal.fire({
                                toast: true,
                                position: 'top-end',
                                customClass: {
                                    container: 'dctoastcontainer'
                                },
                                icon: 'error',
                                title: self.status,
                                showConfirmButton: false,
                                timer: 2500
                            });
                        }
                    }
                });

            }
        }
});


export class ContactComponent {
    public Init(lancurrent: string, captchapublickey: string, statutreu: string, statutfail: string, view_register_validate_requis: string, view_register_validate_emailinvalid:string) {
        gstatutreu = statutreu;
        gstatutfail = statutfail;
        glancurrent = lancurrent;
        gcaptchapublickey = captchapublickey;
        gview_register_validate_requis = view_register_validate_requis;
        gview_register_validate_emailinvalid = view_register_validate_emailinvalid;
        DCApp.mixins = [mixin];
        const app = Vue.createApp(DCApp);
        const pinia = createPinia();
        app.use(pinia);
        app.mount('#rootpage');
    }
}
(<any>(window)).ContactComponent = function () { return new ContactComponent(); };